import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Discard = styled.span.withConfig({
  displayName: "Discard",
  componentId: "sc-1jcrmw8-0"
})(["cursor:pointer;text-decoration:underline;", ";"], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    span {\n      display: none;\n    }\n  "]))));
export var DiscardButton = styled.div.withConfig({
  displayName: "Discard__DiscardButton",
  componentId: "sc-1jcrmw8-1"
})(["position:absolute;top:19px;right:30px;cursor:pointer;", ";", ";"], maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    right: 24px;\n  "]))), maxMediaQueries.phone(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    right: 15px;\n  "]))));